/**
 * This class handles the JS side of the shrinking/growing for toggling element visibility
 *
 * The CSS needs to apply the following properties:
 * transition: height {duration} ease-in-out;
 *
 * For the closed state:
 * height: 0;
 *
 * For the open state:
 * height: auto;
 */
export class ElementToggler {
    constructor(selector, duration = 300) {
        this.selector = selector;
        this.duration = duration;
    }
    hide(parent) {
        window.clearTimeout(this.timeoutId);
        const body = parent.querySelector(this.selector);
        if (body) {
            // Hide overflowing content to enforce the height
            body.style.overflow = 'hidden';
            // Set the CSS height to the actual content height (transitions don't work with 'auto')
            body.style.height = body.scrollHeight + 'px';
            // Shrink down to zero height
            this.timeoutId = window.setTimeout(() => body.style.height = '', 10);
        }
    }
    show(parent) {
        window.clearTimeout(this.timeoutId);
        const body = parent.querySelector(this.selector);
        if (body) {
            // Set the CSS height to the actual content height
            body.style.height = body.scrollHeight + 'px';
            // Remove the CSS height and overflow restriction after transition is done in case the content resizes
            this.timeoutId = window.setTimeout(() => {
                body.style.overflow = '';
                body.style.height = '';
            }, this.duration);
        }
    }
}
//# sourceMappingURL=toggler.js.map
